import React, {createContext, useContext, useState} from "react";


const ContextAccountManagementRefreshList = createContext();

export default function Context_Provider_AccountManagement_RefreshList({children}){
    const [Accounts_Refresh_Indicator, Accounts_Refresh] = useState(0);

    const List_Refresh = () => {
        Accounts_Refresh(Accounts_Refresh_Indicator => Accounts_Refresh_Indicator + 1);
    }

    return (
        <ContextAccountManagementRefreshList.Provider value={{ Accounts_Refresh_Indicator, List_Refresh }}>
            {children}
        </ContextAccountManagementRefreshList.Provider>
    )
}

export function useAccountsListRefresh(){
    return useContext(ContextAccountManagementRefreshList);
}